import { isEmpty } from 'lodash';
import * as Yup from 'yup';

import { PROJECT_MNG_TYPE_CD } from '../constants';

const projectFormValidationSchema = Yup.object().shape({
  projectNm: Yup.string().required('프로젝트명을 입력해주세요.'),
  deprtCd: Yup.string().required('부서를 선택해주세요.'),
  projectTypeCd: Yup.string().required('프로젝트 구분을 선택해주세요.'),
  projectStatusCd: Yup.string().required('프로젝트 상태를 선택해주세요.'),

  // 계약 정보 관련 필드들을 하나의 조건으로 처리
  cntrctNm: Yup.string().test({
    name: 'contractFieldsRequired',
    message: '계약명을 입력해주세요',
    test: function (value) {
      const { contractCmpy, projectMngTypeCd, projectMngId } = this.parent;
      const hasAnyContractField = Boolean(
        value || !isEmpty(contractCmpy) || projectMngTypeCd || projectMngId,
      );

      if (!hasAnyContractField) return true; // 아무 필드도 작성되지 않았으면 통과
      return Boolean(value);
    },
  }),
  contractCmpy: Yup.object().test({
    name: 'contractFieldsRequired',
    message: '계약사를 선택해주세요.',
    test: function (value) {
      const { cntrctNm, projectMngTypeCd, projectMngId } = this.parent;
      const hasAnyContractField = Boolean(
        cntrctNm || !isEmpty(value) || projectMngTypeCd || projectMngId,
      );

      if (!hasAnyContractField) return true;
      return !isEmpty(value);
    },
  }),
  projectMngTypeCd: Yup.string().test({
    name: 'contractFieldsRequired',
    message: '프로젝트 관리 유형을 선택해주세요.',
    test: function (value) {
      const { cntrctNm, contractCmpy, projectMngId } = this.parent;
      const hasAnyContractField = Boolean(
        cntrctNm || !isEmpty(contractCmpy) || value || projectMngId,
      );

      if (!hasAnyContractField) return true;
      return Boolean(value);
    },
  }),
  projectMngId: Yup.string().test({
    name: 'contractFieldsRequired',
    message: '프로젝트 관리 ID는 필수입니다.',
    test: function (value) {
      const { cntrctNm, contractCmpy, projectMngTypeCd } = this.parent;
      const hasAnyContractField = Boolean(
        cntrctNm || !isEmpty(contractCmpy) || projectMngTypeCd || value,
      );

      if (!hasAnyContractField) return true;
      return Boolean(value);
    },
  }),

  // 기성내역 validation - 과제가 아닌 경우에만 검증
  projectRoundSales: Yup.array().when('projectMngTypeCd', {
    is: (val: number | string | undefined) =>
      !val || Number(val) !== PROJECT_MNG_TYPE_CD.ASSIGNMENT,
    then: (schema) =>
      schema.of(
        Yup.object().shape({
          amt: Yup.number().min(1, '기성금액을 입력해주세요.'),
        }),
      ),
    otherwise: (schema) => schema,
  }),

  // 그 외 매입내역 validation - 과제가 아닌 경우에만 검증
  purchaseOthers: Yup.array().when('projectMngTypeCd', {
    is: (val: number | string | undefined) => val && Number(val) !== PROJECT_MNG_TYPE_CD.ASSIGNMENT,
    then: (schema) =>
      schema.of(
        Yup.object().shape({
          category: Yup.string()
            .required('항목을 입력해주세요.')
            .max(100, '100자 이내로 입력해주세요.'),
          vender: Yup.string()
            .required('업체를 입력해주세요.')
            .max(100, '100자 이내로 입력해주세요.'),
        }),
      ),
    otherwise: (schema) => schema,
  }),

  // 과제용 매입내역 validation - 과제인 경우에만 검증
  purchaseAssignments: Yup.array().when('projectMngTypeCd', {
    is: (val: number | string | undefined) => Number(val) === PROJECT_MNG_TYPE_CD.ASSIGNMENT,
    then: (schema) =>
      schema.of(
        Yup.object().shape({
          category: Yup.string()
            .required('비목을 입력해주세요.')
            .max(100, '100자 이내로 입력해주세요.'),
          plan: Yup.string()
            .required('계획을 입력해주세요.')
            .max(100, '100자 이내로 입력해주세요.'),
          contractAmt: Yup.number().min(0, '계약금액은 0 이상이어야 합니다.'),
          usedAmt: Yup.number().min(0, '사용금액은 0 이상이어야 합니다.'),
        }),
      ),
    otherwise: (schema) => schema,
  }),
});

export default projectFormValidationSchema;
